export const LIST_PROGRAMS = 'LIST_PROGRAMS';
export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';
export const DISMISS_SCOPE_NOTIF = 'DISMISS_SCOPE_NOTIF';
export const ACCOUNT = 'ACCOUNT';
export const SELECT_MANDANTS = 'SELECT_MANDANTS';
export const INDICATORS = 'INDICATORS';
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR';
